// (c) Copyright Ascensio System SIA 2009-2025
//
// This program is a free software product.
// You can redistribute it and/or modify it under the terms
// of the GNU Affero General Public License (AGPL) version 3 as published by the Free Software
// Foundation. In accordance with Section 7(a) of the GNU AGPL its Section 15 shall be amended
// to the effect that Ascensio System SIA expressly excludes the warranty of non-infringement of
// any third-party rights.
//
// This program is distributed WITHOUT ANY WARRANTY, without even the implied warranty
// of MERCHANTABILITY or FITNESS FOR A PARTICULAR  PURPOSE. For details, see
// the GNU AGPL at: http://www.gnu.org/licenses/agpl-3.0.html
//
// You can contact Ascensio System SIA at Lubanas st. 125a-25, Riga, Latvia, EU, LV-1021.
//
// The  interactive user interfaces in modified source and object code versions of the Program must
// display Appropriate Legal Notices, as required under Section 5 of the GNU AGPL version 3.
//
// Pursuant to Section 7(b) of the License you must retain the original Product logo when
// distributing the program. Pursuant to Section 7(e) we decline to grant you any rights under
// trademark law for use of our trademarks.
//
// All the Product's GUI elements, including illustrations and icon sets, as well as technical writing
// content are licensed under the terms of the Creative Commons Attribution-ShareAlike 4.0
// International. See the License terms at http://creativecommons.org/licenses/by-sa/4.0/legalcode

import React from "react";
import { ReactSVG } from "react-svg";
import PeopleIcon from "PUBLIC_DIR/images/people.react.svg?url";
import CrossReactSvg from "PUBLIC_DIR/images/icons/12/cross.react.svg?url";
import classNames from "classnames";

import { Text } from "../text";
import { IconButton } from "../icon-button";

import styles from "./PublicRoomBar.module.scss";
import { PublicRoomBarProps } from "./PublicRoomBar.types";

const PublicRoomBar = (props: PublicRoomBarProps) => {
  const {
    ref,
    headerText,
    bodyText,
    iconName,
    onClose,
    barIsVisible,
    className,
    dataTestId,
    ...rest
  } = props;

  const headerAs = typeof headerText !== "string" ? "div" : undefined;
  const bodyAs = typeof bodyText !== "string" ? "div" : undefined;

  return (
    <div
      className={classNames(
        "public-room-bar",
        styles.container,
        {
          [styles.barVisible]: barIsVisible,
        },
        className,
      )}
      {...rest}
      ref={ref}
      data-testid={dataTestId ?? "public_room_bar"}
    >
      <div className={styles.textContainer}>
        <div className={styles.headerBody}>
          <div className={styles.headerIcon}>
            <ReactSVG src={iconName || PeopleIcon} />
          </div>
          <Text className={styles.header} fontWeight={600} as={headerAs}>
            {headerText}
          </Text>
        </div>
        <Text
          className={styles.body}
          fontSize="12px"
          fontWeight={400}
          as={bodyAs}
        >
          {bodyText}
        </Text>
      </div>

      {onClose ? (
        <IconButton
          className={styles.closeIcon}
          size={12}
          iconName={CrossReactSvg}
          onClick={onClose}
        />
      ) : null}
    </div>
  );
};
PublicRoomBar.displayName = "PublicRoomBar";

export default PublicRoomBar;
